<template>
  <div :class="$style.root">
    <i18nLink
      v-if="attributes?.slug"
      :to="{ name: 'education-slug', params: { slug: attributes?.slug } }"
      :locale="i18nCode"
      :class="$style.link"
    >
      <LayoutImageWithCaptionComponent>
        <template #image>
          <CoreImageComponent
            v-if="attributes?.coverImage?.data?.attributes"
            :image="attributes?.coverImage?.data?.attributes"
            :class="$style.coverImage"
            :showCaption="false"
            :data-orientation="getOrientation(attributes?.coverImage?.data?.attributes)"
          />
          <div
            v-else
            :class="$style.coverImagePlaceholder"
          >
            {{ title }}
          </div>
        </template>

        <template #caption>
          <span :class="$style.title">{{ title }}</span>
          <div
            v-if="firstParagraph"
            v-html="firstParagraph"
          />
        </template>
      </LayoutImageWithCaptionComponent>
    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    data: Object
  })

  const localizedData = baseStrapiGetLocalizedData(props.data)

  const attributes = baseStrapiGetAttributes(localizedData)
  const i18nCode = baseI18nGetCodeForIso(attributes?.locale)

  // NOTE extract to base, make part of component, also add square
  const getOrientation = (image) => {
    if (image?.width && image?.height) {
      return image.width > image.height ? 'landscape' : 'portrait'
    }
  }

  const title = baseTruncateString(attributes?.title, 14)

  const firstParagraph = baseStrapiGetFirstParagraphFromBlocks(attributes?.blocks)
</script>

<style module>
  .root {
    --layout--image-with-caption--padding-left: 0;
    --layout--image-with-caption--padding-right: 0;
  }

  .link {
    composes: reset-link from global;
  }

  .link[class*='router-link-exact-active'] {
    color: var(--color--gray);
    pointer-events: none;
  }

  .heading {
  }

  .title {
    composes: font-helvetica font-size-small from global;
    text-decoration-line: underline;
  }


  .link:hover .title {
    text-decoration-line: none;
  }

  .type {
    composes: font-size-small font-helvetica label-inverted from global;
  }

  .coverImage {
    --base--image--object-fit: cover;
    --base--image--aspect-ratio: 3 / 2;
    display: flex;
    justify-content: center;
  }


  .coverImage[data-orientation='portrait'] {
    --base--image--object-fit: cover;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }

  .coverImagePlaceholder {
    composes: font-helvetica font-size-x-large from global;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 3 / 2;

    background-color: var(--color--gray);
    color: var(--color--black);
    overflow: hidden;

    padding: var(--padding--element);

  }

  .updatedAt {
    composes: font-helvetica font-size-small from global;
  }
</style>
